(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-page"] && !Shopify.designMode) return;
  try {
    
  class BundlePage extends HTMLElement {
    constructor() {
      super();
      this.configurator = null;
    }

    connectedCallback() {
      import(this.dataset.configuratorSrc)
        .then((module) => {
          this.configurator = new module.BundleConfigurator(this);
        })
        .catch((err) => {
          console.error('Failed to load bundle configurator:', err);
        });
    }
  }

  customElements.define('bundle-page', BundlePage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-address"] && !Shopify.designMode) return;
  try {
    
  class GiftAddress extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      import(this.dataset.giftSrc)
        .then((module) => {
          this.controller = new module.GiftAddressController(this);
        })
        .catch((err) => {
          console.error('Failed to load gift address controller:', err);
          this.querySelectorAll('[data-state]').forEach((node) => {
            node.hidden = node.dataset.state !== 'error';
          });
        });
    }
  }

  if (!customElements.get('gift-address')) {
    customElements.define('gift-address', GiftAddress);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-checkout"] && !Shopify.designMode) return;
  try {
    
  class GiftCheckout extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      import(this.dataset.giftSrc)
        .then((module) => {
          this.controller = new module.GiftCheckoutController(this);
        })
        .catch((err) => {
          console.error('Failed to load gift checkout controller:', err);
        });
    }
  }

  if (!customElements.get('gift-checkout')) {
    customElements.define('gift-checkout', GiftCheckout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-note"] && !Shopify.designMode) return;
  try {
    
  class GiftNote extends HTMLElement {
    connectedCallback() {
      // Wait 3: fill "A note for [Name]" from session before the module loads.
      const waitHeading = this.querySelector('[data-page-wait-heading]');
      const template = this.dataset.headingTemplate || 'A note for __GIFTER__';
      if (waitHeading) {
        try {
          const token = new URLSearchParams(window.location.search).get('token');
          const raw = token ? sessionStorage.getItem('nb_gift_redemption') : null;
          const parsed = raw ? JSON.parse(raw) : null;
          const gifter =
            parsed?.token === token
              ? String(parsed?.gift?.gifter_first_name || '')
              : '';
          waitHeading.textContent = template.replace('__GIFTER__', gifter);
        } catch {
          waitHeading.textContent = template.replace('__GIFTER__', '');
        }
      }

      if (this.controller) return;
      import(this.dataset.giftSrc)
        .then((module) => {
          this.controller = new module.GiftNoteController(this);
        })
        .catch((err) => {
          console.error('Failed to load gift note controller:', err);
          this.querySelectorAll('[data-state]').forEach((node) => {
            node.hidden = node.dataset.state !== 'error';
          });
        });
    }
  }

  if (!customElements.get('gift-note')) {
    customElements.define('gift-note', GiftNote);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-recipient"] && !Shopify.designMode) return;
  try {
    
  class GiftRecipient extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      import(this.dataset.giftSrc)
        .then((module) => {
          this.controller = new module.GiftRecipientController(this);
        })
        .catch((err) => {
          console.error('Failed to load gift recipient controller:', err);
          this.querySelectorAll('[data-state]').forEach((node) => {
            node.hidden = node.dataset.state !== 'error';
          });
        });
    }
  }

  if (!customElements.get('gift-recipient')) {
    customElements.define('gift-recipient', GiftRecipient);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-review"] && !Shopify.designMode) return;
  try {
    
  class GiftReview extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      import(this.dataset.giftSrc)
        .then((module) => {
          this.controller = new module.GiftReviewController(this);
        })
        .catch((err) => {
          console.error('Failed to load gift review controller:', err);
        });
    }
  }

  if (!customElements.get('gift-review')) {
    customElements.define('gift-review', GiftReview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const heroMobileMq = window.matchMedia('(max-width: 749px)');

  function loadHeroViewportVideo(video) {
    if (video.dataset.heroVideoLoaded) return;

    const sources = JSON.parse(video.dataset.heroVideoSources);
    sources.forEach(({ url, type }) => {
      const source = document.createElement('source');
      source.src = url;
      source.type = type;
      video.appendChild(source);
    });

    video.preload = 'auto';
    video.load();
    video.play().catch(() => {});
    video.dataset.heroVideoLoaded = 'true';

    // Seamless loop, HLS-safe: handled by the shared dual-buffer implementation
    // in snippets/video.liquid (avoids the segment re-fetch stutter a plain
    // seek-to-0 causes on .m3u8 streams).
    if (typeof applyDualBufferLoop === 'function') {
      applyDualBufferLoop(video);
    }
  }

  function shouldLoadHeroVideo(video, isMobile, hasMobileSpecificMedia) {
    if (!hasMobileSpecificMedia) return true;

    const viewport = video.dataset.heroVideoViewport;
    if (!viewport) return true;
    if (isMobile) return viewport === 'mobile';
    return viewport === 'desktop';
  }

  function removeHeroVideoElement(video) {
    video.pause();
    video.removeAttribute('src');
    video.querySelectorAll('source').forEach((source) => source.remove());
    const wrapper = video.closest('.hero__media-wrapper');
    if (wrapper) {
      wrapper.remove();
    } else {
      video.remove();
    }
  }

  function initHeroViewportVideos(hero) {
    const isMobile = heroMobileMq.matches;
    const hasMobileSpecificMedia = hero.dataset.heroHasMobileSpecificMedia === 'true';
    const hasMobileMedia = hero.dataset.heroHasMobileMedia === 'true';
    const desktopOnly = hero.querySelectorAll(
      '.hero__media-wrapper--desktop:not(.hero__media-wrapper--mobile)'
    );
    const mobileOnly = hero.querySelectorAll(
      '.hero__media-wrapper--mobile:not(.hero__media-wrapper--desktop)'
    );

    if (isMobile && !hasMobileMedia) {
      desktopOnly.forEach((wrapper) => wrapper.remove());
      hero.querySelectorAll('video[data-hero-video-viewport="desktop"]').forEach((video) => {
        removeHeroVideoElement(video);
      });
      return;
    }

    if (isMobile && hasMobileSpecificMedia) {
      desktopOnly.forEach((wrapper) => wrapper.remove());
    } else if (!isMobile && hasMobileSpecificMedia) {
      mobileOnly.forEach((wrapper) => wrapper.remove());
    }

    hero.querySelectorAll('video[data-hero-video-viewport]').forEach((video) => {
      if (hasMobileSpecificMedia && !shouldLoadHeroVideo(video, isMobile, hasMobileSpecificMedia)) {
        removeHeroVideoElement(video);
      }
    });

    hero.querySelectorAll('[data-hero-video-sources]').forEach((video) => {
      if (shouldLoadHeroVideo(video, isMobile, hasMobileSpecificMedia)) {
        loadHeroViewportVideo(video);
      }
    });
  }

  function initAllHeroViewportVideos() {
    document.querySelectorAll('.hero').forEach(initHeroViewportVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeroViewportVideos);
  } else {
    initAllHeroViewportVideos();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["made-by-none-better"] && !Shopify.designMode) return;
  try {
    
  function mbnbBind(root) {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-mbnb-row]').forEach((row) => {
      if (row.dataset.mbnbBound === 'true') return;
      row.dataset.mbnbBound = 'true';
      const scroller = row.querySelector('[data-mbnb-scroller]');
      const prev = row.querySelector('[data-mbnb-prev]');
      const next = row.querySelector('[data-mbnb-next]');
      if (!scroller || !prev || !next) return;

      const update = () => {
        // Arrows on every breakpoint when the row actually overflows
        // (mobile/tablet included). No arrows when everything fits.
        const sizeOverflow = scroller.scrollWidth > scroller.clientWidth + 8;

        row.classList.toggle('is-overflow', sizeOverflow);
        if (!sizeOverflow) {
          prev.hidden = true;
          next.hidden = true;
          if (scroller.scrollLeft) scroller.scrollLeft = 0;
          return;
        }
        prev.hidden = scroller.scrollLeft < 4;
        next.hidden = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
      };

      prev.addEventListener('click', () => {
        scroller.scrollBy({ left: -scroller.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
      next.addEventListener('click', () => {
        scroller.scrollBy({ left: scroller.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(update).observe(scroller);
      }
      requestAnimationFrame(() => requestAnimationFrame(update));
    });
  }

  function mbnbInit() {
    document.querySelectorAll('.mbnb').forEach(mbnbBind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mbnbInit);
  } else {
    mbnbInit();
  }
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('.mbnb') || event.target;
    if (root?.classList?.contains('mbnb')) mbnbBind(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
